<template>
  <div>
    <v-card>
      <v-card-title>守信企业设置</v-card-title>

      <v-card-text>
         <v-btn  color="error" @click="handleSaveData()">
                保存
              </v-btn>
        <v-form ref="form">
          <v-text-field
            label="副标题"
            v-model="form.TitleSecond"
            :rules="rules2"
            hide-details="auto"
          ></v-text-field>
          <div style="margin-top: 10px">
            <vue-ueditor-wrap
              v-model="form.Contents"
              :config="myConfig"
              @beforeInit="handleAddCustom"
            />
          </div>
          <input
            ref="inputImg"
            type="file"
            accept=".jpg, .jepg, .png, .bmp, .gif,"
            style="display: none"
            @change="handleUploadImg"
          />
          <input
            ref="inputFile"
            type="file"
            accept=".pdf, .zip, .7z, doc, docx, xls, xlsx, txt,"
            style="display: none"
            @change="handleUploadFile"
          />
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from "../../http/apis/apis";
export default {
  data() {
    return {
      valid: true,
      form: {
        Id: null,
        TitleSecond: "",
        Contents: "",
        ComeFrom: "企业自主公开",
      },
      dialog: false,
      rules2: [(value) => !!value || "请输入副标题"],
      Editor: null,
      myConfig: {
        toolbars: [
          [
            "source",
            "|",
            "undo",
            "redo",
            "|",
            "bold",
            "italic",
            "underline",
            "fontborder",
            "strikethrough",
            "superscript",
            "subscript",
            "removeformat",
            "formatmatch",
            "autotypeset",
            "blockquote",
            "pasteplain",
            "|",
            "forecolor",
            "backcolor",
            "insertorderedlist",
            "insertunorderedlist",
            "selectall",
            "cleardoc",
            "|",
            "rowspacingtop",
            "rowspacingbottom",
            "lineheight",
            "|",
            "customstyle",
            "paragraph",
            "fontfamily",
            "fontsize",
            "|",
            "directionalityltr",
            "directionalityrtl",
            "indent",
            "|",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "|",
            "touppercase",
            "tolowercase",
            "|",
            // 'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|'
            // 'simpleupload', 'insertimage', 'emotion', 'scrawl', 'insertvideo', 'music', 'attachment', 'map', 'gmap', 'insertframe', 'insertcode', 'webapp', 'pagebreak', 'template', 'background', '|',
            "horizontal",
            "date",
            "time",
            "spechars",
            "|",
            // 'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
            "print",
            "preview",
            "searchreplace",
          ],
        ],
        // 编辑器不自动被内容撑高
        autoHeightEnabled: true,
        // 初始容器高度
        initialFrameHeight: 600,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: "",
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "/UEditor/",
      },
      BASE_URL: "",
      tableData: [],
      totalCount: 0,
      tableLoading: false,
      pageData: {
        MenuId: 221,
        Order: "desc",
        Page: 1,
        Rows: 15,
        Value: "",
        StartIndex: 0,
        sort: "CreateTime",
      },
      tableHeaders: [
        { text: "文章标题", sortable: false, value: "Title" },
        // { text: '类型', sortable: false, value: 'Name' },
        // { text: '来源', sortable: false, value: 'ComeFrom' },
        // { text: '是否置顶', sortable: false, value: 'IsTop' },
        // { text: '访问次数', sortable: false, value: 'Hits' },
        // { text: '收藏次数', sortable: false, value: 'CollectCount' },
        // { text: '排序', sortable: false, value: 'Sequence' },
        { text: "创建时间", value: "CreateTime" },
        { text: "操作", sortable: false, value: "Id" },
      ],
    };
  },
  created() {
    this.BASE_URL = this.CONSTS.BASE_URL;
    this.getBasicInfo();
  },
  methods: {
    async handleUploadImg(e) {
      const fd = new FormData();
      fd.append("fileImg", e.target.files[0]);
      const { data } = await api.reportApi2.uploadImg(fd);
      if (data.IsSuccessful) {
        this.Editor.execCommand(
          "inserthtml",
          '<img src="' + this.BASE_URL + data.ResultData + '" />'
        );
      }
    },
    async handleUploadFile(e) {
      const fd = new FormData();
      fd.append("fileData", e.target.files[0]);
      const { data } = await api.reportApi2.UploadFile(fd);
      if (data.IsSuccessful) {
        const resName = this.handleGetFileUrl(data.ResultData);
        this.Editor.execCommand(
          "inserthtml",
          '<a target="_blank" href="' +
            this.BASE_URL +
            data.ResultData +
            '">' +
            resName +
            "</a>"
        );
      }
    },

    async handleSaveData() {
      if (this.$refs.form.validate()) {
        const fd = new FormData();
        fd.append("Id", this.form.Id);
        fd.append("TitleSecond", this.form.TitleSecond);
        fd.append("ComeFrom", this.form.ComeFrom);
        fd.append("Contents", this.form.Contents);
        const { data } = await api.companyApi2.saveCompanyCreditInfo(fd);
        if (data.IsSuccessful) {
           this.$message({
          showClose: true,
          message: '保存成功',
          type: "success",
        });
          this.getBasicInfo();
        }else {
        this.$message({
          showClose: true,
          message: data.ResultMsg||"[守信企业保存]未知错误，请联系管理员",
          type: "error",
        });
      }
      }
    },
   
    handleAddCustom(editorId) {
      window.UE.registerUI(
        "test-img",
        (editor, uiName) => {
          var btn = new window.UE.ui.Button({
            name: "upload-img",
            title: uiName,
            cssRules: `background-position: -380px 0;`,
            onclick: () => {
              this.Editor = editor;
              this.$refs.inputImg.click();
            },
          });
          return btn;
        },
        51,
        editorId
      );
      window.UE.registerUI(
        "test-File",
        (editor, uiName) => {
          var btn2 = new window.UE.ui.Button({
            name: "upload-File",
            title: uiName,
            cssRules: `background-position: -620px -40px;`,
            onclick: () => {
              this.Editor = editor;
              this.$refs.inputFile.click();
            },
          });
          return btn2;
        },
        52,
        editorId
      );
    },

    handleGetFileUrl(file) {
      if (file) {
        return file.substring(file.lastIndexOf("/") + 1);
      } else {
        return "";
      }
    },
    async getBasicInfo() {
      const { data } = await api.companyApi2.getCompanyCreditInfo();
      if (data.IsSuccessful) {
        this.form = data.ResultObj || {
          Id: 0,
          TitleSecond: "",
          Contents: "",
          ComeFrom: "企业自主公开",
        };
        console.info("add data",this.form)
      } else {
        this.$message({
          showClose: true,
          message: data.ResultMsg,
          type: "error",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .myDialog {
  z-index: 99999;
  background: red !important;
}
::v-deep .edui-editor-toolbarbox {
  position: relative !important;
}
</style>
